module.exports = {
  width: 163,
  height: 164,
  bytes: 13048,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};